export enum CheckInStatus {
  Failed,
  Success,
  SpoofingSuspected,
}

export enum ProfileType {
  Employee,
  Guest,
}
